export default __webpack_public_path__ + "static/media/nodejs.31d93e46.svg";